import { render } from "./CardGameContainer.vue?vue&type=template&id=4afcf89e&scoped=true"
import script from "./CardGameContainer.vue?vue&type=script&lang=js"
export * from "./CardGameContainer.vue?vue&type=script&lang=js"

import "./CardGameContainer.vue?vue&type=style&index=0&id=4afcf89e&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afcf89e"]])

export default __exports__